import axios from 'axios'

// Axios instance aligned with other services
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:5000/api',
  headers: { 'Content-Type': 'application/json' },
})

// Attach token if present (keep consistency)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})


const clientService = {

async getAgentClients() {
  try {
    const response = await api.get(`/client/get-customer-by-id`);
    return response.data;
  } catch (error) {
    console.error('Error get client details:', error);
    throw error;
  }
},


async createNewClient(customerDetails) {
  try {
    const response = await api.post(`/client/save-customer-details`,customerDetails);
    return response.data;
  } catch (error) {
    console.error('Error adding a customer:', error);
    throw error;
  }
},


async getAgentClientsWithPagination(page = 1, limit = 6, search = '') {
  try {
    const response = await api.get(`/client/get-customer-with-pagination`, {
      params: {
        page: page,
        limit: limit,
        search: search 
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error get client details:', error);
    throw error;
  }
},


async deleteClient(clientId) {
  try {
    const response = await api.delete(`/client/delete-client/${clientId}`);
    return response.data
  } catch (error) {
    console.error('Error delete client:', error);
    throw error
  }
},


async updateClient (clientID, customerDetails) {
  try {
    const response = await api.put(`/client/update-customer/${clientID}`,customerDetails);
    return response.data;
  } catch (error) {
    console.error('Error adding a customer:', error);
    throw error;
  }
},

}

export default clientService


